import React, { useEffect, useRef, useState } from "react";
import { ArrowUpRight, MapPin, Train, Bus, Plane, Truck } from "lucide-react";
import { CONTACTS, MAPS_URL } from "../mock";

const TRANSIT = [
  { Icon: Train, label: "Stazione ferroviaria Torino/Collegno 5 minuti" },
  { Icon: Bus, label: "Metro a 2 fermate di autobus" },
  { Icon: Plane, label: "Navetta gratuita dall'aeroporto" },
  { Icon: Truck, label: "Consegna a casa" },
];

export default function Location() {
  const pipeRef = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = pipeRef.current;
    if (!el) return undefined;
    const ob = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setInView(true); ob.disconnect(); } },
      { threshold: 0.35 }
    );
    ob.observe(el);
    return () => ob.disconnect();
  }, []);
  return (
    <section className="cm-reveal border-y border-[var(--cm-line)] py-16">
      <div className="mx-auto max-w-[1360px] px-6 lg:px-10">
        <div className="flex flex-col justify-between gap-8 md:flex-row md:items-center">
          <div>
            <p className="label-mono mb-4">Dove trovarci</p>
            <h2 className="h-display flex items-start gap-2.5 text-[clamp(1.5rem,2.6vw,2.1rem)]">
              <MapPin className="mt-0.5 shrink-0 text-[var(--cm-green)]" size={22} />
              {CONTACTS.address}
            </h2>
            <p className="mt-4 text-[0.95rem] text-[#7a7a72]">{CONTACTS.hours}</p>
            <ul ref={pipeRef} className={`cm-pipe${inView ? " cm-pipe-in" : ""}`}>
              {TRANSIT.map(({ Icon, label }, i) => (
                <li key={label} className="cm-pipe-item" style={{ transitionDelay: `${i * 130}ms` }}>
                  <span className="cm-pipe-node">
                    <Icon size={15} />
                  </span>
                  <span className="text-[0.9rem] text-[#5b5b54]">{label}</span>
                </li>
              ))}
            </ul>
          </div>
          <a
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 self-start rounded-full border border-[var(--cm-line)] px-6 py-3.5 text-[0.9rem] font-medium transition-all duration-200 hover:border-[var(--cm-ink)] md:self-center"
          >
            Indicazioni stradali
            <ArrowUpRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
}
